<script setup lang="ts">
import CloudflareText from "@/assets/icons/cloudfare-text.svg?url";
import CloudflareIcon from "@/assets/icons/cloudfare.svg?url";
import { UIAlert, UICheckbox } from "@gohighlevel/ghl-ui";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
  invisible: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="challenge-element">
    <div
      :class="[
        'inline-flex items-center justify-start gap-7 rounded border border-gray-200 bg-gray-50 p-3 mb-1.5',
        { 'challenge-invisible-mode': invisible },
      ]"
    >
      <!-- Checkbox Section -->
      <div class="flex items-start justify-start gap-2">
        <UICheckbox
          id="challenge-checkbox"
          :checked="false"
          :disabled="false"
        >
          {{ t("fields.customized.verifyHuman") }}
        </UICheckbox>
      </div>

      <!-- Cloudflare Logo Section -->
      <div class="inline-flex flex-col items-end justify-center gap-1">
        <div class="flex flex-col items-end justify-start gap-0.5">
          <img :src="CloudflareIcon" alt="Cloudflare" class="h-5 w-auto" />
          <img :src="CloudflareText" alt="Cloudflare" class="h-2 w-auto" />
        </div>
        <div class="inline-flex items-center justify-end gap-1 self-stretch">
          <a
            href="https://www.cloudflare.com/privacypolicy/"
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs font-normal leading-4 text-gray-500 underline"
          >
            {{ t("fields.customized.privacy") }}
          </a>
          <div class="h-1 w-1 rounded-full bg-gray-500"></div>
          <a
            href="https://www.cloudflare.com/help/"
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs font-normal leading-4 text-gray-500 underline"
          >
            {{ t("fields.customized.help") }}
          </a>
        </div>
      </div>
    </div>
    <div v-if="invisible">
      <UIAlert
        id="captcha-hidden-warning"
        type="warning"
        :closable="false"
      >
        <template #content>
          {{ t("fields.customized.fieldHiddenWarning") }}
        </template>
      </UIAlert>
    </div>
  </div>
</template>

<style scoped>

.challenge-invisible-mode {
  opacity: 0.4;
}
</style>
